import normalHearingIcon from './normal.png';
import mildHearingIcon from './mild.png';
import severeHearingIcon from './severe.png';
import infoIcon from './info-icon.png';
export var bestBuyImages = {
    normalHearingIcon: normalHearingIcon,
    mildHearingIcon: mildHearingIcon,
    severeHearingIcon: severeHearingIcon,
    infoIcon: infoIcon,
};
